// Indietro.tsx — il pulsante tondo con la freccia «indietro» della nuova grafica (v019).
import { useTranslation } from "react-i18next";

export function Indietro({ onClick, etichetta }: { onClick: () => void; etichetta?: string }) {
  const { t } = useTranslation();
  return (
    <button type="button" className="ld-indietro" aria-label={etichetta ?? t("account.indietro")} onClick={onClick}>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M15 5l-7 7 7 7" />
      </svg>
    </button>
  );
}
